import React from 'react'

const Flexbox_Coding_Pratice_6 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 6</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_6
